import { render, staticRenderFns } from "./fundus-photo.vue?vue&type=template&id=8172a732&"
import script from "./fundus-photo.vue?vue&type=script&lang=js&"
export * from "./fundus-photo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports